import { render, staticRenderFns } from "./BorrowersForm.vue?vue&type=template&id=6773053e&scoped=true&"
import script from "./BorrowersForm.vue?vue&type=script&lang=js&"
export * from "./BorrowersForm.vue?vue&type=script&lang=js&"
import style0 from "./BorrowersForm.vue?vue&type=style&index=0&id=6773053e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6773053e",
  null
  
)

export default component.exports